export default __webpack_public_path__ + "assets/niue-flag.png";